<template>
  <MainLayout>
    <b-row id="topGavContainer">
      <b-col
        class="shadow-sm"
        style
      >
        <b-card-body>
          <u-error-handling
            v-if="errorObject"
            :error-object="errorObject"
          />
          <b-pagination
            v-model="currentPage"
            :total-rows="currentPageLinks.length"
            :per-page="resultsPerPage"
            prev-text="Vorherige"
            next-text="Nächste"
            first-text="<<"
            last-text=">>"
            class="float-right"
          />
          <h4
            class="card-title font-weight-bold"
            style="margin-bottom: 40px"
          >
            Assets Validieren
          </h4>
          <u-loader v-if="isLoading" />
          <template v-else>
            <v-container fluid>
              <b-row>
                <b-col
                  cols="12"
                  sm="2"
                  md="2"
                  class="pt-2"
                >
                  Text
                </b-col>
                <b-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <input
                    v-model="textFilter"
                    type="text"
                    class="form-control"
                    placeholder="Text"
                  >
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col
                  cols="12"
                  sm="2"
                  md="2"
                  class="pt-2"
                >
                  Url
                </b-col>
                <b-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <input
                    v-model="urlFilter"
                    type="text"
                    class="form-control"
                    placeholder="Text"
                  >
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col
                  cols="12"
                  sm="2"
                  md="2"
                  class="pt-4"
                >
                  <b>Sprachen</b>
                </b-col>
                <b-col
                  cols="12"
                  sm="2"
                  md="2"
                >
                  <v-checkbox
                    v-model="checkedLanguages"
                    label="Deutsch"
                    value="de-CH"
                  />
                </b-col>
                <b-col
                  cols="12"
                  sm="2"
                  md="2"
                >
                  <v-checkbox
                    v-model="checkedLanguages"
                    label="Französisch"
                    value="fr-CH"
                  />
                </b-col>
                <b-col
                  cols="12"
                  sm="2"
                  md="2"
                >
                  <v-checkbox
                    v-model="checkedLanguages"
                    label="Italienisch"
                    value="it-CH"
                  />
                </b-col>
              </b-row>
            </v-container>
            <table class="w-100 validateAssets ml-2 mt-4">
              <thead>
                <tr>
                  <th
                    class="cursor-pointer"
                    @click="SortedPropertyClicked('Text')"
                  >
                    <span class="float-left mr-1">Text</span>
                    <u-sorting-up-down
                      :value="SortedProperty == 'Text' ? SortOrder : -1"
                    />
                  </th>
                  <th
                    class="cursor-pointer"
                    @click="SortedPropertyClicked('URL')"
                  >
                    <span class="float-left mr-1">URL</span>
                    <u-sorting-up-down
                      :value="SortedProperty == 'URL' ? SortOrder : -1"
                    />
                  </th>
                  <th>Sprache</th>
                  <th>Vertrag</th>
                  <th>Aktion</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="link in currentPageLinks.slice(
                    (currentPage - 1) * resultsPerPage,
                    currentPage * resultsPerPage,
                  )"
                  :key="link.linkId + link.language"
                >
                  <td class="py-1">
                    {{ link.description }}
                  </td>
                  <td class="py-1">
                    <a
                      target="_blank"
                      :href="link.url"
                    >{{ link.url }}</a>
                  </td>
                  <td class="py-1">
                    {{ link.language }}
                  </td>
                  <td class="py-1">
                    <a
                      :href="`/contract-overview/${link.contractNumber}/${link.versionNumber}`"
                    >{{ link.value }} ({{
                      `${link.contractNumber}/${link.versionNumber}`
                    }})</a>
                  </td>
                  <td class="py-1">
                    <button
                      v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
                      v-b-modal.editLink
                      v-b-tooltip.hover
                      type="button"
                      placement="bottom"
                      title="Link bearbeiten"
                      class="btn btn-primary smallActionButton"
                      @click="
                        currentModalLink = link.linkId;
                        GetSingleLink(link.linkId);
                      "
                    >
                      <i class="fas fa-edit" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </b-card-body>
      </b-col>
    </b-row>
    <b-modal
      id="editLink"
      ref="editLink"
      hide-footer
      title="Link bearbeiten"
      size="xl"
      no-fade
    >
      <u-error-handling
        v-if="singleLinkErrorObject"
        :error-object="singleLinkErrorObject"
      />
      <u-loader v-if="singleLinkLoading" />
      <template v-else-if="editLink">
        <div
          v-for="(content, index) in editLink.contents"
          :key="content.id"
        >
          <b>{{ content.language }} (<a
            target="_blank"
            :href="content.url"
          >{{
            content.value
          }}</a>)</b>

          <b-row>
            <b-col
              cols="3"
              class="mt-4"
            >
              Text
            </b-col><b-col cols="9">
              <v-text-field v-model="content.value" />
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="3"
              class="mt-4"
            >
              URL
            </b-col><b-col cols="9">
              <v-text-field v-model="content.url" />
            </b-col>
          </b-row>

          <hr v-if="index + 1 < editLink.contents.length">
        </div>
      </template>
      <b-button
        variant="success"
        @click="saveLink()"
      >
        Speichern
      </b-button>
      <b-button
        class="ml-2"
        variant
        @click="hideModal"
      >
        Abbrechen
      </b-button>
    </b-modal>
    <div style="height: 500px" />
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import { GetInvalidLinks } from "@/services/validate.assets.service.js";
import USortingUpDown from "@/components/common/USortingUpDown.vue";
import {
  UpdateLink,
  GetSingleLink,
} from "@/services/contract.edition.links.service.js";

export default {
  components: {
    MainLayout,
    USortingUpDown,
  },
  data() {
    return {
      isLoading: false,
      singleLinkLoading: false,
      errorObject: null,
      singleLinkErrorObject: null,
      invalidLinks: [],
      pagedLinks: [],
      numberOfItems: 0,
      checkedLanguages: ["de-CH", "fr-CH", "it-CH"],
      urlFilter: "",
      textFilter: "",
      SortedProperty: null,
      SortOrder: 0,
      totalNumberOfContracts: 0,
      currentPage: 1,
      resultsPerPage: 50,
      searchString: "",
      editLink: null,
    };
  },
  computed: {
    currentPageLinks() {
      var filterSorted = JSON.parse(JSON.stringify(this.invalidLinks));

      this.resetPaging();

      filterSorted = filterSorted.filter((item) => {
        var itemMatch = false;
        var haslanguage = this.checkedLanguages.indexOf(item.language) != -1;
        var hasText =
          item.description
            .toLowerCase()
            .indexOf(this.textFilter.toLowerCase()) != -1 || !this.textFilter;
        var hasUrl =
          item.url.toLowerCase().indexOf(this.urlFilter.toLowerCase()) != -1 ||
          !this.urlFilter;

        itemMatch = (haslanguage && hasText && hasUrl) || itemMatch;

        return itemMatch;
      });

      if (this.SortOrder != -1) {
        var that = this;
        if (this.SortedProperty == "Text") {
          filterSorted.sort(function (a, b) {
            var textA = a.description.toUpperCase().trimLeft();
            var textB = b.description.toUpperCase().trimLeft();
            var result = textA < textB ? -1 : textA > textB ? 1 : 0;
            return that.SortOrder == 0 ? result : result * -1;
          });
        }

        if (this.SortedProperty == "URL") {
          filterSorted.sort(function (a, b) {
            var textA = a.url.toUpperCase().trimLeft();
            var textB = b.url.toUpperCase().trimLeft();
            var result = textA < textB ? -1 : textA > textB ? 1 : 0;
            return that.SortOrder == 0 ? result : result * -1;
          });
        }
      }

      return filterSorted;

      //return JSON.parse(JSON.stringify(this.invalidLinks.filter(item => { return this.checkedLanguages.indexOf(item.contents[0].language) != -1}).slice((this.currentPage-1)*this.resultsPerPage, (this.currentPage)*this.resultsPerPage)))
    },
  },
  created() {
    this.GetInvLinks();
  },
  methods: {
    resetPaging() {
      this.currentPage = 1;
    },
    SortedPropertyClicked(property) {
      if (this.SortedProperty == property) {
        switch (this.SortOrder) {
          case -1:
            this.SortOrder = 0;
            break;
          case 0:
            this.SortOrder = 1;
            break;
          case 1:
            this.SortOrder = -1;
            break;
          default:
            this.SortOrder = -1;
            break;
        }

        // this.GetAllContractsFiltered();
      } else {
        this.SortedProperty = property;
      }
    },
    hideModal() {
      this.$refs["editLink"].hide();
    },
    GetSingleLink(linkId) {
      this.singleLinkLoading = true;
      GetSingleLink(
        "1",
        "1",
        "1",
        linkId,
        (success) => {
          this.singleLinkLoading = false;
          this.editLink = success;
        },
        (error) => {
          this.singleLinkErrorObject = error;
          this.singleLinkLoading = false;
        },
      );
    },
    saveLink() {
      this.singleLinkLoading = true;

      UpdateLink(
        "1",
        "1",
        "1",
        this.editLink.id,
        this.editLink,
        () => {
          this.singleLinkLoading = false;
          this.hideModal();
          this.GetInvLinks();
        },
        (error) => {
          this.singleLinkErrorObject = error;
          this.singleLinkLoading = false;
        },
      );
    },
    GetInvLinks() {
      this.isLoading = true;

      GetInvalidLinks(
        (response) => {
          this.isLoading = false;
          this.invalidLinks = JSON.parse(JSON.stringify(response));
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style>
.overflowHiddenEllipsis {
  text-overflow: ellipsis;
  overflow: hidden;
}

.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}
</style>

<style scoped>
.validateAssets td:nth-child(1) {
  width: 500px;
  max-width: 500px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  padding-right: 5px;
}
.validateAssets td:nth-child(2) {
  width: 500px;
  max-width: 500px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  padding-right: 5px;
}
.validateAssets td:nth-child(3) {
  max-width: 10%;
  width: 10%;
}
.validateAssets td:nth-child(4) {
  width: 500px;
  max-width: 500px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  padding-right: 5px;
}
.validateAssets td:nth-child(5) {
  max-width: 10%;
  width: 10%;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
